const RegionTabId = "RegionTab";
const WholeDenmarkTabId = "WholeDenmarkTab";
const MineTabId = "MineTab";

export {
    RegionTabId,
    WholeDenmarkTabId,
    MineTabId
}